import { render } from "./TrainModel.vue?vue&type=template&id=89bc9362&scoped=true"
import script from "./TrainModel.vue?vue&type=script&lang=js"
export * from "./TrainModel.vue?vue&type=script&lang=js"

import "./TrainModel.vue?vue&type=style&index=0&id=89bc9362&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89bc9362"]])

export default __exports__